import { useDispatch, useSelector } from 'react-redux';

import { ScormAssessment, Scorm } from './types';
import { clearScormAction, clearScormAssessmentAction, getScorm, setScormAction, setScormAssessmentAction } from './redux/slice';

const useScorm = () => {
  const scorm = useSelector(getScorm);
  const dispatch = useDispatch();

  const setScorm = (receivedScorm: Scorm) => {
    dispatch(setScormAction(receivedScorm));
  };

  const clearScorm = () => {
    dispatch(clearScormAction());
  };

  const setScormAssessment = (receivedScormAssessment: ScormAssessment) => {
    dispatch(setScormAssessmentAction(receivedScormAssessment));
  };

  const clearScormAssessment = () => {
    dispatch(clearScormAssessmentAction());
  };

  return {
    ...scorm,

    setScorm,
    clearScorm,

    setScormAssessment,
    clearScormAssessment,
  };
};

export default useScorm;
